import React from "react";
import { SubmenuTitle } from "../components/SubmenuTitle";
import { Reactangle } from "../infos/Reactangle";

import pic from "../../assets/images/leftbar.png";
import { pageInfo, ShowInfo } from "../../models/system";
import { getShowings } from "../../apis/api";
export class Base extends React.Component {
    state = { infos: null as pageInfo<ShowInfo> | null, curpage: 0 as number }
    componentDidMount(): void {
        getShowings(0, 0, 12).then((data) => {

            this.setState({ infos: data });
            this.forceUpdate();

        });
        document.querySelector(".btn._more")?.addEventListener("click", () => {

            if (this.state.infos!.content.length <= this.state.infos!.pageCount) {
                this.setState({ curpage: this.state.curpage + 1 })
                getShowings(0, this.state.curpage, 12).then((data) => {
                    let c = this.state.infos!.content;
                    this.state.infos!.content = [...this.state.infos!.content, ...data.content];

                    this.forceUpdate();
                });
            }
        })
    }

    render(): React.ReactNode {
        return (
            <>

                <div className="base">
                    {
                        this.state.infos?.content?.map((item, index) =>

                            <div className="item">
                                <img src={item.pic} alt=""></img>
                                <p className="title">{item.title}</p>
                                <p className="address">展览地点：{item.address}</p>
                                <p className="time">展览时间：{item.date}</p>
                            </div>
                        )
                    }
                </div>
                <div className="btn _more">更多</div>
            </>
        )

    }
}

